import { useEffect, useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';

const InputLabeled = ({...props}) => {
    const [open, setOpen] = useState(false);
    const [inputType, setInputType] = useState('password');

    const handleChange = (event) => {
        event.preventDefault();
        props.setValue(event.target.value);
    }

    const toggleEye = () => { setOpen(!open); }

    useEffect(() => {
        setInputType(open ? 'text' : 'password');
    }, [open]);

    return (
        <div className={`input-group ${props.className}`}>
            <input
                type={inputType}
                ref={props.innerRef}
                style={props.style}
                autoFocus={props.autoFocus}
                onFocus={props.onFocus}
                onBlur={props.onBlur}
                value={props.value}
                onChange={handleChange}
                className={`form-control`}
                placeholder={props.hint}
                disabled={props.disabled}/>
            <span onClick={toggleEye} className={`btn border border-gray d-flex align-items-center justify-content-center`}>
                {open ? <EyeOff size={16}/> : <Eye size={16}/>}
            </span>
        </div>
    );
}

export default InputLabeled;